/**
 * Detect PostgREST "undefined column" errors (migration not applied yet).
 *
 * @param {object|null} error - Supabase error object.
 * @param {string} columnName - Column name to check in the message.
 * @returns {boolean}
 */
export function isMissingColumnError(error, columnName) {
  if (!error) return false;
  if (error.code !== '42703') return false;
  const msg = String(error.message || '');
  return msg.includes(columnName);
}

/**
 * Sessions list select (no transcript). Includes extraction_config when migration is applied.
 * @type {string}
 */
export const SESSIONS_LIST_SELECT_WITH_EXTRACTION_CONFIG = `
  id,
  project_id,
  name,
  description,
  extraction_type,
  extraction_config,
  file_info,
  summary,
  source,
  source_metadata,
  created_at,
  updated_at
`;

/**
 * Same as {@link SESSIONS_LIST_SELECT_WITH_EXTRACTION_CONFIG} but without extraction_config.
 * @type {string}
 */
export const SESSIONS_LIST_SELECT_LEGACY = `
  id,
  project_id,
  name,
  description,
  extraction_type,
  file_info,
  summary,
  source,
  source_metadata,
  created_at,
  updated_at
`;
